import React, { useState } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

export default function TopYellow() {
  const [isOpen, setIsOpen] = useState(true);

  function changeIsOpen(v) {
    setIsOpen(v);
  }

  if (!isOpen) return null;

  return (
    <StyledTopYellow>
      <p className="topYellow_text">
        Учитесь в группе с помощью наставника! 2 недели. 990 ₽. Начинаем 17
        марта 📚 <Link to="#">Подробнее</Link>
      </p>
      <Link
        to="#"
        className="js_hideTopYellow"
        onClick={() => changeIsOpen(false)}
      >
        ×
      </Link>
    </StyledTopYellow>
  );
}

const StyledTopYellow = styled.div`
  position: relative;
  background-color: rgb(255, 217, 41);
  padding: 24px 0;

  .topYellow_text {
    text-align: center;
    font-size: 18px;
    font-weight: 500;
    line-height: 24px;
    color: rgb(0, 0, 0);
    margin-bottom: 0;

    a {
      text-decoration: underline;
      padding: 0 4px;
    }
  }

  .js_hideTopYellow {
    position: absolute;
    font-size: 24px;
    height: 32px;
    width: 32px;
    cursor: pointer;
    top: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  @media (max-width: 576px) {
    .topYellow_text {
      margin: 0 16px;
      color: red;
    }
  }
`;
